import { HeadingItem } from "components";
import { NavigationEntryContext, TripContext } from 'contexts';
import FileUploader from 'devextreme-react/file-uploader';
import notify from 'devextreme/ui/notify';
import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLoadManagerService, useNavigation, useSettingService, useTripService, useImageUploadService } from 'services';
import './app-debug.scss';

export const AppDebug = () => {

    const {getImagesFromBlobStorage} = useImageUploadService();
    const { updateTripData, clearReasons } = useLoadManagerService()
    const { clearSettings, updateSettings } = useSettingService()
    let { clearTrips } = useTripService()
    const [selectedFile, setSelectedFile] = useState<File>()
    const fileReader = new FileReader();

    const navigate = useNavigate()
    const tripContext = useContext(TripContext)
    const navigationContext = useContext(NavigationEntryContext)
    const { navigateTo } = useNavigation()

    useEffect(() => {
        const loadAppState = async () => {
            if (selectedFile != null) {
                fileReader.onload = async function (e) {

                    const jsonResult = fileReader.result && JSON.parse(fileReader.result.toString());
                    const dbData = jsonResult.payload
                    if (dbData) {
                        await Promise.all([
                            clearTrips(),
                            clearReasons(),
                            clearSettings(),
                            navigationContext.navigationEntries.set([])
                        ])

                        await Promise.all([
                            updateSettings(dbData.appSettings),
                            tripContext.stopEquipments.set(dbData.stopEquipments),
                            tripContext.stops.set(dbData.stops),
                            tripContext.catchWeights.set(dbData.catchWeights),
                            tripContext.companies.set(dbData.companies),
                            tripContext.licensePlates.set(dbData.licensePlates),
                            tripContext.lineItemBarcodes.set(dbData.lineItemBarcodes),
                            tripContext.licensePlateItems.set(dbData.licensePlateItems),
                            tripContext.lineItems.set(dbData.lineItems),
                            tripContext.mispicks.set(dbData.mispicks),
                            tripContext.orderItemChanges.set(dbData.orderItemChanges),
                            tripContext.orderItems.set(dbData.orderItems),
                            tripContext.orderLicensePlates.set(dbData.orderLicensePlates),
                            tripContext.orders.set(dbData.orders),
                            tripContext.returnItems.set(dbData.returnItems),
                            tripContext.signatures.set(dbData.signatures),
                            tripContext.trips.set(dbData.trips),
                            tripContext.verifyMultipleItemsReasons.set(dbData.verifyMultipleItemsReasons),
                            tripContext.reconcileReasons.set(dbData.reconcileReasons),
                            tripContext.refusalReasons.set(dbData.refusalReasons),
                            tripContext.equipmentShortReasons.set(dbData.equipmentShortReasons),
                            tripContext.returnChangeReasons.set(dbData.returnChangeReasons),
                            tripContext.equipmentTypes.set(dbData.equipmentTypes),
                            tripContext.syncStatus.set(dbData.syncStatus),
                            tripContext.filteredLicensePlates.set(dbData.filteredLicensePlates),
                            tripContext.orderItemChangeImages.set(dbData.orderItemChangeImages), 
                            navigationContext.navigationEntries.set(dbData.navigationEntries)
                        ])
                        let orderItemChangeImageArray = tripContext.orderItemChangeImages.toArray();

                        if(orderItemChangeImageArray && orderItemChangeImageArray.length>0)
                        {
                            for(const orderItemChangeImage of orderItemChangeImageArray!)
                            {
                                let imageFile = await getImagesFromBlobStorage(orderItemChangeImage.filenameInBlobStorage, orderItemChangeImage)

                                if(imageFile.file === "" || imageFile.objectUrl === "")
                                {
                                    notify(`Image ${orderItemChangeImage.filenameInBlobStorage} was not found in Blob Storage`, 'error', 5000)
                                }
                            }
                        }

                        await navigate(dbData.currentURL)
                    }
                    else {
                        notify('Could not load app state: "payload" is required', 'error', 5000)
                    }
                };
                fileReader.readAsText(selectedFile);

            }
            else {
                notify('Could not load app state: invalid file', 'error', 5000)
            }
        }

        if (selectedFile != null) {
            loadAppState()
        }
    }, [selectedFile])

    return (
        <>
            <div className='card-material'>
                <HeadingItem text={'Load App State'} />
                <FileUploader
                    multiple={false}
                    accept={'application/JSON'}
                    uploadFile={(file: File) => setSelectedFile(file)}
                />
            </div>

            <div className='card-material'>
                <HeadingItem text={'Test Barcodes'} />
                <div className={'app-debug-barcode-view'} onClick={() => navigateTo('test-barcodes')}>View Barcodes</div>
            </div>
        </>
    )
};